import { Const } from '~/constants/Const.constant';
import { WeatherModule } from '~/models/modules/netatmo/WeatherModule.model';

export class NAModule3 extends WeatherModule {

    battery_levels = {
        full : Const.NABatteryLevelRainGaugeModule.RG_BATTERY_LEVEL_0,
        high : Const.NABatteryLevelRainGaugeModule.RG_BATTERY_LEVEL_1,
        medium : Const.NABatteryLevelRainGaugeModule.RG_BATTERY_LEVEL_2,
        low : Const.NABatteryLevelRainGaugeModule.RG_BATTERY_LEVEL_3,
    };
}
